module.exports = __webpack_public_path__ + "static/media/foto_portada.425199dd.jpg";